<template>
  <div class="zcbody bodymain1" style="width:96%;margin:0 auto;">

    <!-- <div class="zc-header">
      <div class="head">
        <div class="logo">
          <img src="../../assets/images/logo.png" />
        </div>
        <span class="logintext">认养一头牛SRM供应商管理平台</span>
      </div>
    </div> -->
    <div class="contanerpric" style="width:100%;">
      <el-card class="box-card boxcard">
        <div slot="header" class="clearfix">
          <b>开标列表</b>
        </div>
        <!-- 可以使用span 和 span-map对象来控制栅格的大小 -->
        <el-table :data="tableData" border style="width: 100%;" class="tb-edit" highlight-current-row :header-cell-style="{ background: '#eef1f6', textAlign: 'center' }" :cell-style="{textAlign: 'center' }">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column label="开始询价" width="90" prop="cbeginask"></el-table-column>
          <el-table-column label="报价过程显示" width="120" prop="cbjshow"></el-table-column>
          <el-table-column prop="dxjstart" label="询价开始日期" width="110">
            <template slot-scope="scope">
              <span v-if="scope.row.dxjstart"> {{scope.row.dxjstart.substring(0,10)}}</span>

            </template>
          </el-table-column>
          <!-- <el-table-column prop="cclasscode" label="类别编号" width="110"></el-table-column> -->
          <el-table-column prop="cclassname" label="物料类别名称" width="110"></el-table-column>
          <el-table-column prop="ccode" label="送货单号" width="110"></el-table-column>
          <!-- <el-table-column prop="ccommit" label="紧急程度" width="100"></el-table-column> -->
          <!-- <el-table-column prop="ccorpcode" label="工厂编号" min-width="120"></el-table-column> -->
          <el-table-column prop="ccorpname" label="公司名称" width="140"></el-table-column>
          <el-table-column prop="ccqname" label="超期报价人" width="120"></el-table-column>
          <!-- <el-table-column prop="cdepcode" label="部门编号" width="110"></el-table-column> -->
          <el-table-column prop="cdjms" label="定价描述" width="110"></el-table-column>
          <el-table-column prop="cinquirycode" label="询价单号" width="110"></el-table-column>
          <el-table-column prop="cinquiryinfo" label="询价信息" width="160"></el-table-column>
          <el-table-column prop="cishtsigned" label="是否签订合同" min-width="120"></el-table-column>
          <el-table-column prop="cispaymargin" label="是否缴纳保证金" width="120"></el-table-column>
          <el-table-column prop="cmaker" label="发起人" width="90"></el-table-column>
          <!-- <el-table-column prop="cmakercode" label="创建者编号" width="110"></el-table-column> -->
          <el-table-column prop="coadjcode" label="OA定价单号" width="110"></el-table-column>
          <el-table-column prop="cordertype" label="订单类型" width="90"></el-table-column>

          <!-- <el-table-column prop="cposcode" label="创建者编号" width="110"></el-table-column> -->
          <el-table-column prop="coadjcode" label="OA定价单号" width="110"></el-table-column>
          <!-- <el-table-column prop="cposcode" label="订单类型" width="140"></el-table-column> -->
          <el-table-column prop="cpricing" label="定价方式" width="90"></el-table-column>
          <el-table-column prop="cqcxjcode" label="期初询价单号" width="120"></el-table-column>
          <el-table-column prop="cquotation" label="报价方式" width="90"></el-table-column>
          <el-table-column prop="cqyname" label="启用人" width="90"></el-table-column>
          <el-table-column prop="cstate" label="审批状态" width="90"></el-table-column>
          <el-table-column prop="cstopname" label="停用人" width="90"></el-table-column>
          <el-table-column prop="cstopreason" label="停止原因" width="140"></el-table-column>

          <!-- <el-table-column prop="ctempid" label="新增临时ID" width="100"></el-table-column> -->
          <!-- <el-table-column prop="ctypecode" label="期初询价单号" width="180"></el-table-column> -->
          <!-- <el-table-column prop="curgent" label="紧急程度" width="110"></el-table-column> -->
          <el-table-column prop="curgent" label="紧急程度" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.curgent">
                <el-tag type="warning" v-if="scope.row.curgent=='普通'">{{scope.row.curgent}}</el-tag>
                <el-tag type="danger" v-if="scope.row.curgent=='紧急'">{{scope.row.curgent}}</el-tag>
              </span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="cversion" label="启用人" width="110"></el-table-column> -->
          <el-table-column prop="cvery" label="审核人" width="90"></el-table-column>
          <!-- <el-table-column prop="cxj_id" label="询价单总ID" width="110"></el-table-column> -->
          <el-table-column prop="cxjtype" label="询价类型" width="140"></el-table-column>

          <el-table-column prop="dcommit" label="提交日期" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.dcommit">{{scope.row.dcommit.substring(0,10)}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="dcqtime" label="超期报价日期" width="110">
            <template slot-scope="scope">
              <span v-if="scope.row.dcqtime">{{scope.row.dcqtime.substring(0,10)}}</span>
            </template>
          </el-table-column>

          <el-table-column prop="ddate" label="申请日期" width="110">
            <template slot-scope="scope">
              <span v-if="scope.row.ddate">{{scope.row.ddate.substring(0,10)}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="dqytime" label="启用日期" width="110">
            <template slot-scope="scope">
              <span v-if="scope.row.dqytime">{{scope.row.dqytime.substring(0,10)}}</span>
            </template>
          </el-table-column>

          <el-table-column prop="dstoptime" label="停止日期" width="110">
            <template slot-scope="scope">
              <span v-if="scope.row.dstoptime">{{scope.row.dstoptime.substring(0,10)}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="dverydate" label="审核日期" width="110">
            <template slot-scope="scope">
              <span v-if="scope.row.dverydate">{{scope.row.dverydate.substring(0,10)}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="dxjend" label="询价截至日期" width="110">
            <template slot-scope="scope">
              <span v-if="scope.row.dxjend">{{scope.row.dxjend.substring(0,10)}}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="dxjstart" label="询价开始日期" width="110">
            <template slot-scope="scope" v-if="scope.row.dxjstart">
              {{scope.row.dxjstart.substring(0,10)}}
            </template>
          </el-table-column> -->

          <el-table-column prop="ibjnumber" label="允许报价次数" width="110"></el-table-column>
          <el-table-column prop="idbjven" label="待报价厂商数" width="110"></el-table-column>

          <el-table-column prop="imarginprice" label="保证金金额" width="110"></el-table-column>
          <!-- <el-table-column prop="imonth" label="月份" width="110"></el-table-column> -->

          <el-table-column prop="iordernumber" label="已订购数量" width="110"></el-table-column>
          <el-table-column prop="isgnumber" label="申购数量" width="90"></el-table-column>
          <el-table-column prop="ixjnumber" label="询价次数" width="90"></el-table-column>
          <el-table-column prop="ixjquantity" label="询价数量" width="90"></el-table-column>
          <el-table-column prop="iybjven" label="已报价厂商数" width="110"></el-table-column>
          <!-- <el-table-column prop="iyear" label="年份" width="110"></el-table-column> -->
          <!-- <el-table-column prop="dcreatetime" label="询价类型" width="140"></el-table-column> -->
          <el-table-column label="操作" width="120" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" plain @click="supedit(scope.row)">查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pull-right" style="padding:20px;">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[20, 50, 100, 1000]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
          </el-pagination>
        </div>
      </el-card>

    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      pageSize: 20,
      pageIndex: 1,
      // 页数
      totalCount: 0,
      cop: "",
    };
  },
  created() {
    this.cop = this.getUrlKey("cop");
    // this.cop = "enFoJDIwMjEtMTEtMjQgMTU6NDc6MTc=";
    if (this.cop != "") {
      this.GetLogInfoByCode();
    }
  },
  methods: {
    getUrlKey(name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.href
          ) || [, ""])[1].replace(/\+/g, "%20")
        ) || null
      );
    },
    GetLogInfoByCode() {
      this.$axios({
        method: "post",
        url: "CommonModule/Op_Supplier/GetLogInfoByCode",
        data: { clogincode: this.cop },
      }).then((res) => {
        console.log(res, "撤销结果");

        if (res.data.Success) {
          this.GetInquiryAllList();
        } else {
          this.$message.error(res.data.Message);
        }
      });
    },
    GetInquiryAllList() {
      this.$axios({
        method: "post",
        url: "CommonModule/Op_Supplier/GetInquiryAllList",
        // data: { KeyValue: "ZG91cGFucWlhbyQyMDIxLTEwLTIxIDEzOjQ1OjE1" },
      }).then((res) => {
        console.log(res, "撤销结果");

        if (res.data.Success) {
          this.tableData = res.data.Data;
        } else {
          this.$message.error(res.data.Message);
        }
      });
    },
    supedit(row) {
      this.$router.push({
        path: "/opentrendersonform",
        query: { id: row.id, cop: this.cop },
      });
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetInquiryAllList();
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetInquiryAllList();
    },
  },
};
</script>

<style scoped>
@import url(../../assets/css/reg.css);
</style>

